import React, { useState } from "react";
import { Select } from "antd";
import { FilterField } from "./FilterShared";

const BASE_SELECT = { style: { width: "100%" }, allowClear: true };

const EducationPanel = ({ values, set }) => {
  const [search, setSearch] = useState("");
  return (
    <div className="qp-filter-panel-body">
      <FilterField label="Degree or Institution">
        <Select
          {...BASE_SELECT}
          mode="tags"
          placeholder="e.g. Bachelor's, Harvard University"
          tokenSeparators={[","]}
          value={values.school}
          onChange={set("school")}
          open={search.length > 0}
          onSearch={setSearch}
          onBlur={() => setSearch("")}
        />
      </FilterField>
    </div>
  );
};

export default EducationPanel;
